import { FC, MouseEvent } from "react";

import { Box, ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";

export type TChartLayoutMode = "2d" | "3d";

export interface IChartLayoutToggle {
  mode: TChartLayoutMode;
  tooltip: string;
  layout2dLabel: string;
  layout3dLabel: string;
  onChange: (value: TChartLayoutMode) => void;
}

export const ChartLayoutToggle: FC<IChartLayoutToggle> = props => {
  const { mode, tooltip, layout2dLabel, layout3dLabel, onChange } = props;

  const handleChange = (_: MouseEvent<HTMLElement>, value: TChartLayoutMode | null) => {
    if (value !== null) {
      onChange(value);
    }
  };

  return (
    <Box sx={{ flexShrink: 1, minWidth: 0, overflow: "hidden" }}>
      <Tooltip title={tooltip} arrow>
        <ToggleButtonGroup
          exclusive
          size="small"
          value={mode}
          onChange={handleChange}
          aria-label={tooltip}
          sx={{
            mx: 2,
            mt: 0.5,
            "& .MuiToggleButton-root": {
              fontSize: 12,
              py: 0.25,
              px: 1,
            },
          }}
        >
          <ToggleButton value="2d" key="2d">
            {layout2dLabel}
          </ToggleButton>
          <ToggleButton value="3d" key="3d">
            {layout3dLabel}
          </ToggleButton>
        </ToggleButtonGroup>
      </Tooltip>
    </Box>
  );
};
